<template>
  <div class="header-container">
    <el-header class="header-content">
      <!-- 移动端菜单按钮 -->
      <div class="mobile-menu-btn" @click="toggleMobileMenu" v-if="isMobile">
        <i class="el-icon-menu"></i>
      </div>

      <!-- 左侧：品牌Logo区域 -->
      <div class="header-left">
        <div class="logo-area">
         
          <div class="logo-text" v-if="!isMobile">
            <span class="title">{{proxy?proxy.real_name:'管理员'}}</span>
            <span class="slogan">智慧商业 · 数据驱动</span>
          </div>
        </div>
      </div>

      <!-- 右侧：用户操作 -->
      <div class="header-right">
        <!-- 日期时间显示 -->
        <div class="datetime-info">
          <i class="el-icon-date"></i>
          <div class="datetime-content">
            <span class="date">{{ nowDate }}</span>
            <span class="week">{{ nowWeek }}</span>
          </div>
        </div>

        <!-- 用户下拉菜单 -->
        <el-dropdown class="user-dropdown" trigger="click" placement="bottom-end">
          <div class="user-account">
            <div class="user-avatar">
              <i class="el-icon-user-solid"></i>
            </div>
            <div class="user-info" v-if="!isMobile">
              <div class="user-name">{{ userName }}</div>
              <div class="user-role">{{ proxy ? proxy.role_name : '系统管理员' }}</div>
            </div>
            <i class="el-icon-arrow-down arrow-icon"></i>
          </div>
          <el-dropdown-menu slot="dropdown" class="user-menu">
            <el-dropdown-item @click.native="userInfo" class="menu-item">
              <i class="el-icon-user"></i>
              <span>个人中心</span>
            </el-dropdown-item>
            <el-dropdown-item @click.native="changePassword" class="menu-item">
              <i class="el-icon-lock"></i>
              <span>修改密码</span>
            </el-dropdown-item>
            <el-dropdown-item divided @click.native="logout" class="menu-item logout-item">
              <i class="el-icon-switch-button"></i>
              <span>退出登录</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </el-header>

    <!-- 修改密码弹框 -->
    <el-dialog
      title="修改密码"
      :visible.sync="dialogPassword"
      width="460px"
      :append-to-body="true"
      custom-class="password-dialog"
      center
      @closed="handleDialogClosed"
    >
      <div class="dialog-icon">
        <i class="el-icon-lock"></i>
      </div>
      <el-form :model="pwdForm" :rules="pwdRules" ref="pwdForm" label-width="100px" label-position="right">
        <el-form-item label="账号" prop="user_name">
          <el-input
            v-model="pwdForm.user_name"
            readonly
            disabled
            placeholder="请输入账号"
            prefix-icon="el-icon-user">
          </el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="password">
          <el-input
            v-model="pwdForm.password"
            type="password"
            autocomplete="off"
            placeholder="请输入新密码"
            prefix-icon="el-icon-key"
            show-password>
          </el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="repassword">
          <el-input
            v-model="pwdForm.repassword"
            type="password"
            autocomplete="off"
            placeholder="请再次输入新密码"
            prefix-icon="el-icon-key"
            show-password>
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelPwdForm" class="cancel-btn">取 消</el-button>
        <el-button type="primary" @click="submitPwdForm" class="submit-btn">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { hexMD5 } from '../../utils/md5'

export default {
  name: "HeaderView",
  data() {
    // 自定义密码确认验证规则
    const validateRepass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入新密码'))
      } else if (value !== this.pwdForm.password) {
        callback(new Error('两次输入的密码不一致'))
      } else {
        callback()
      }
    }

    return {
      nowWeek: "",
      nowDate: "",
      userName: '',
      proxy: null,
      isMobile: false,
      dialogPassword: false,
      pwdForm: {
        user_name: sessionStorage.getItem('userName') || '',
        password: '',
        repassword: '',
      },
      pwdRules: {
        password: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          { min: 6, message: "密码长度不能少于6位", trigger: "blur" }
        ],
        repassword: [
          { required: true, message: "请再次输入新密码", trigger: "blur" },
          { validator: validateRepass, trigger: 'blur' }
        ],
      },
    }
  },
  created() {
    this.setNowTimes()
    this.userName = window.sessionStorage.getItem('userName') || '管理员'
    const proxyData = sessionStorage.getItem("proxy")
    if (proxyData) {
      this.proxy = JSON.parse(proxyData)
    }
    this.checkMobile()
    window.addEventListener('resize', this.checkMobile)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile)
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth < 992
    },

    toggleMobileMenu() {
      this.$emit('toggle-mobile-menu')
    },

    // 个人信息
    userInfo() {
      this.$router.push("/userInfo")
    },

    // 用户退出
    logout() {
      this.$confirm('确定要退出登录吗？', '退出提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true,
        customClass: 'logout-confirm'
      }).then(() => {
        this.$message.success('退出成功')
        window.sessionStorage.clear()
        this.$router.push("/login")
      }).catch(() => {
        this.$message.info('已取消退出')
      })
    },

    // 设置当前时间
    setNowTimes() {
      const myDate = new Date()
      const yy = myDate.getFullYear()
      const mm = String(myDate.getMonth() + 1).padStart(2, '0')
      const dd = String(myDate.getDate()).padStart(2, '0')
      const weeks = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"]
      const week = weeks[myDate.getDay()]
      
      this.nowDate = `${yy}.${mm}.${dd}`
      this.nowWeek = week
    },

    // 修改密码
    changePassword() {
      this.dialogPassword = true
      this.$nextTick(() => {
        if (this.$refs.pwdForm) {
          this.$refs.pwdForm.resetFields()
        }
        this.pwdForm.password = ''
        this.pwdForm.repassword = ''
      })
    },

    handleDialogClosed() {
      this.$refs.pwdForm?.resetFields()
    },

    cancelPwdForm() {
      this.dialogPassword = false
    },

    submitPwdForm() {
      this.$refs.pwdForm.validate((valid) => {
        if (valid) {
          const param = {
            id: sessionStorage.getItem('user_id'),
            password: hexMD5(this.pwdForm.password),
            repassword: hexMD5(this.pwdForm.repassword),
            access_token: sessionStorage.getItem('token'),
          }
          this.$axios.proxyUserChangePsw(param).then(res => {
            if (res.code == 200) {
              this.$message.success(res.msg)
              this.dialogPassword = false
              this.pwdForm.password = ''
              this.pwdForm.repassword = ''
            } else {
              this.$message.error(res.msg || '修改失败')
            }
          }).catch(error => {
            console.log(error)
            this.$message.error('修改失败，请重试')
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.header-container {
  width: 100%;
  height: 100%;
}

.header-content {
  height: 100% !important;
  padding: 0 24px !important;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: linear-gradient(135deg, #fff 0%, #f8f9fc 100%) !important;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  border-bottom: 1px solid #f0f0f0;
}

// 移动端菜单按钮
.mobile-menu-btn {
  display: none;
  cursor: pointer;
  color: #606266;
  font-size: 20px;
  padding: 8px;
  border-radius: 8px;
  margin-right: 12px;
  transition: all 0.3s;

  &:hover {
    background: #f0f7ff;
    color: #1677ff;
  }
}

// 左侧 Logo 区域
.header-left {
  display: flex;
  align-items: center;

  .logo-area {
    display: flex;
    align-items: center;
    gap: 12px;

    .logo-icon {
      width: 40px;
      height: 40px;
      background: linear-gradient(135deg, #1677ff, #69a5ff);
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;

      i {
        font-size: 22px;
        color: #fff;
      }
    }

    .logo-text {
      display: flex;
      flex-direction: column;
      line-height: 1.3;

      .title {
        font-size: 18px;
        font-weight: 600;
        color: #1f2d3d;
        letter-spacing: 0.5px;
      }

      .slogan {
        font-size: 11px;
        color: #8c8f98;
      }
    }
  }
}

// 右侧区域
.header-right {
  display: flex;
  align-items: center;
  gap: 24px;

  // 日期时间
  .datetime-info {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 6px 14px;
    background: #f8f9fc;
    border-radius: 40px;
    transition: all 0.3s;

    i {
      font-size: 18px;
      color: #1677ff;
    }

    .datetime-content {
      display: flex;
      flex-direction: column;
      line-height: 1.3;

      .date {
        font-size: 13px;
        font-weight: 500;
        color: #1f2d3d;
      }

      .week {
        font-size: 11px;
        color: #8c8f98;
      }
    }
  }
}

// 用户下拉菜单
.user-dropdown {
  cursor: pointer;
}

.user-account {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 5px 12px 5px 8px;
  border-radius: 40px;
  transition: all 0.3s;
  background: #f8f9fc;

  &:hover {
    background: #f0f7ff;
  }

  .user-avatar {
    width: 36px;
    height: 36px;
    background: linear-gradient(135deg, #1677ff, #69a5ff);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;

    i {
      font-size: 18px;
      color: #fff;
    }
  }

  .user-info {
    display: flex;
    flex-direction: column;
    line-height: 1.3;

    .user-name {
      font-size: 14px;
      font-weight: 600;
      color: #1f2d3d;
    }

    .user-role {
      font-size: 11px;
      color: #8c8f98;
    }
  }

  .arrow-icon {
    font-size: 12px;
    color: #8c8f98;
    transition: transform 0.3s;
  }
}

// 下拉菜单样式
.user-menu {
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  padding: 8px 0;
  border: none;
  overflow: hidden;

  .menu-item {
    padding: 10px 20px;
    font-size: 14px;
    transition: all 0.2s;

    i {
      margin-right: 10px;
      font-size: 16px;
      color: #8c8f98;
    }

    &:hover {
      background: #f0f7ff;

      i {
        color: #1677ff;
      }

      span {
        color: #1677ff;
      }
    }
  }

  .logout-item {
    color: #ff4d4f;

    i {
      color: #ff4d4f;
    }

    &:hover {
      background: #fff2f0;

      i,
      span {
        color: #ff7875;
      }
    }
  }
}

// 弹框样式
:deep(.password-dialog) {
  border-radius: 20px;
  overflow: hidden;

  .el-dialog__header {
    background: linear-gradient(135deg, #1677ff 0%, #4096ff 100%);
    padding: 20px 24px;
    margin: 0;

    .el-dialog__title {
      color: #fff;
      font-size: 18px;
      font-weight: 500;
    }

    .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
      font-size: 18px;

      &:hover {
        color: rgba(255, 255, 255, 0.8);
      }
    }
  }

  .el-dialog__body {
    padding: 24px;
  }

  .el-dialog__footer {
    padding: 16px 24px 24px;
    border-top: 1px solid #f0f0f0;
  }
}

.dialog-icon {
  text-align: center;
  margin-bottom: 20px;

  i {
    font-size: 56px;
    color: #1677ff;
    background: #e6f4ff;
    padding: 16px;
    border-radius: 60px;
  }
}

:deep(.el-form-item__label) {
  font-weight: 500;
  color: #1f2d3d;
}

:deep(.el-input__inner) {
  border-radius: 8px;
  border-color: #e4e7ed;
  transition: all 0.2s;

  &:focus {
    border-color: #1677ff;
    box-shadow: 0 0 0 2px rgba(22, 119, 255, 0.1);
  }
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;

  .el-button {
    border-radius: 24px;
    padding: 9px 24px;
  }

  .el-button--primary {
    background: #1677ff;
    border-color: #1677ff;

    &:hover {
      background: #4096ff;
      border-color: #4096ff;
    }
  }

  .cancel-btn {
    &:hover {
      color: #1677ff;
      border-color: #1677ff;
    }
  }
}

// 响应式调整
@media screen and (max-width: 1200px) {
  .header-content {
    padding: 0 20px !important;
  }
}

@media screen and (max-width: 992px) {
  .mobile-menu-btn {
    display: block;
  }

  .header-left .logo-text {
    display: none;
  }
}

@media screen and (max-width: 768px) {
  .header-content {
    padding: 0 16px !important;
  }

  .datetime-info {
    display: none !important;
  }

  .user-account .user-info {
    display: none;
  }

  .user-account {
    padding: 5px 10px;
  }
}

@media screen and (max-width: 576px) {
  .header-content {
    padding: 0 12px !important;
  }
}
</style>